<template>
  <div id="wokerDetailDiv">
    <div class="wokerDetailHeader">
      人员详情
    </div>
    <div class="wokerDetailText">
      <div class="wokerDetailTable">
        <table align="center" border="1" height="360" width="400" cellspacing="0">
          <tr>
            <td class="detail">姓名：</td>
            <td class="detail">{{formData.name}}</td>
            <td colspan="2" rowspan="3" width="200" height="180">
              <div style="width: 196px; height: 272px">
                <el-image style="width: 100%; height: 100% " :src="host + formData.picUrl"></el-image>
              </div>
            </td> 
          </tr>
          <tr>
            <td class="detail">性别：</td>
            <td class="detail">{{formData.sex == 1 ? '男' : '女'}}</td>
          </tr>
          <tr>
            <td class="detail">部门：</td>
            <td class="detail">{{formData.deptName}}</td>
          </tr>
          <tr style="height: 60px">
            <td class="detail">岗位：</td>
            <td colspan="3" class="detail">{{formData.jobName}}</td>
          </tr>
          <tr style="height: 60px">
            <td class="detail">设备编号：</td>
            <td colspan="3" class="detail">{{formData.positioningDeviceNumber}}</td>
          </tr>
          <tr style="height: 60px">
            <td class="detail">工号：</td>
            <td colspan="3" class="detail">{{formData.empNo}}</td>
          </tr>
        </table>
      </div>
      <div class="wokerDetailDetail">
        <el-tabs v-model="activeName">
          <!-- <el-tab-pane label="详情" name="xq">
            <el-image style="width: 100px; height: 100px" :src="host + formData.picUrl" fit="fill"></el-image>
            <div class="text item">姓名:{{formData.name}}</div>
            <div class="text item">性别:{{formData.sex}}</div>
            <div class="text item">部门:{{formData.deptName}}</div>
            <div class="text item">岗位:{{formData.jobName}}</div>
            <div class="text item">设备编号:{{formData.positioningDeviceNumber}}</div>
            <div class="text item">工号:{{formData.empNo}}</div>
          </el-tab-pane> -->
          <el-tab-pane label="承诺卡" name="cnk">
            <div class="text"><span>承诺卡名称：</span><span>{{ promise.name }}</span></div>
            <div class="text"><span>承诺卡编号： </span><span>{{ promise.number }}</span></div>
            <div class="text"><span>部门：</span><span>{{ promise.depName }}</span></div>
            <div class="text"><span>部门领导：</span><span>{{ promise.leaderName }}</span></div>
            <div class="text"><span>岗位：</span><span>{{ promise.jobName }}</span></div>
            <div class="text"><span>承诺事项：</span><pre>{{ promise.promiseContent }}</pre></div>
            <div class="text"><span>承诺时间：</span><span>{{ promise.commitmentDate }}</span></div>
            <!-- <div class="text"><span>附件：</span><span>{{ promise.fileName + promise.fileUrl }}</span></div> -->
            <div class="text"><span>附件：</span>
              <el-link :underline="false" type="primary" style="color: #409eff" @click="download(promise.fileUrl, promise.fileName)">{{ promise.fileName }}</el-link>
            </div>
          </el-tab-pane>
          <el-tab-pane label="应急卡" name="yjk">
              <div class="text"><span>应急卡名称：</span><span>{{ emergency.name }}</span></div>
              <div class="text"><span>应急卡编号：</span><span>{{ emergency.aaaaaaaaa }}</span></div>
              <div class="text"><span>部门：</span><span>{{ emergency.depName }}</span></div>
              <div class="text"><span>部门领导：</span><span>{{ emergency.leaderName }}</span></div>
              <div class="text"><span>岗位：</span><span>{{ emergency.jobName }}</span></div>
              <div class="text"><span>工艺附件：</span><span>{{ emergency.craftFileName }}</span></div>
              <div class="text"><span>步骤说明：</span><pre>{{ emergency.procedureExp }}</pre></div>
              <div class="text"><span>事故风险_事故后果： </span><pre>{{ emergency.accidentRisk }}</pre></div>
              <div class="text"><span>发生场所：</span><span>{{ emergency.place }}</span></div>
              <div class="text"><span>危害描述：</span><pre>{{ emergency.harmDescribe }}</pre></div>
              <div class="text"><span>应急处理政策：</span><pre>{{ emergency.emergencyProcessing }}</pre></div>
              <div class="text"><span>内部应急电话：</span><span>{{ emergency.interiorEmergencyCall }}</span></div>
              <div class="text"><span>外部应急电话：</span><span>{{ emergency.externalEmergencyCall }}</span></div>
              <div class="text"><span>附件：</span>
                <el-link :underline="false" type="primary" style="color: #409eff" @click="download(emergency.fileUrl, emergency.fileName)">{{ emergency.fileName }}</el-link>
              </div>
          </el-tab-pane>
          <el-tab-pane label="应知卡" name="yzk">
            <div class="text"><span>感知卡名称：</span><span>{{ should.name }}</span></div>
            <div class="text"><span>编号：</span><span>{{ should.number }}</span></div>
            <div class="text"><span>部门：</span><span>{{ should.depName }}</span></div>
            <div class="text"><span>主要有害因素：</span><pre>{{ should.primaryHarmfulFactor }}</pre></div>
            <div class="text"><span>易导致事故风险：</span><pre>{{ should.accidentLiability }}</pre></div>
            <div class="text"><span>风险等级：</span><span v-if="should.riskLevel">{{ riskLevelArr[should.riskLevel - 1].label }}</span></div>
            <div class="text"><span>风险管控措施：</span><pre>{{ should.riskControlMeasures }}</pre></div>
            <div class="text"><span>应急处置对策：</span><pre>{{ should.emergencyProcessing }}</pre></div>
            <div class="text"><span>安全指示标志：</span><span v-if="should.safetyWarningLabel">{{ saftyArr[should.safetyWarningLabel - 1].label }}</span></div>
            <div class="text"><span>附件：</span>
              <el-link :underline="false" type="primary" style="color: #409eff" @click="download(should.fileUrl, should.fileName)">
                {{ should.fileName }}</el-link>
            </div>
          </el-tab-pane>
          <el-tab-pane label="培训记录" name="pxjl">
            <el-table :data="pxData" style="width: 100%" :header-cell-style="tableTouStyle">
              <el-table-column align="center" prop="courseName" label="培训课程名称"></el-table-column>
              <el-table-column align="center" prop="duration" label="课时（小时）"></el-table-column>
              <el-table-column align="center" prop="actualEndTime" :show-overflow-tooltip="true" label="实际结束时间"></el-table-column>
              <el-table-column align="center" prop="place" :show-overflow-tooltip="true" label="培训地点"></el-table-column>
              <el-table-column align="center" prop="teacher" label="讲师"></el-table-column>
              <el-table-column align="center" prop="contentHtml" label="培训内容"></el-table-column>
              <el-table-column align="center" prop="trainStatus" label="培训状态"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="个人证书" name="grzs">
            <el-table :data="zsData" style="width: 100%" :header-cell-style="tableTouStyle">
              <el-table-column align="center" prop="certificateNo" label="证书编号"></el-table-column>
              <el-table-column align="center" prop="authorizeProject" label="批准项目"></el-table-column>
              <el-table-column align="center" prop="issuingAuthority" label="发证机关"></el-table-column>

              <el-table-column align="center" prop="getCertificateTime" :show-overflow-tooltip="true" label="领证日期"></el-table-column>
              <el-table-column align="center" prop="expireTime" :show-overflow-tooltip="true" label="到期时间"></el-table-column>
              <el-table-column align="center" prop="gmtCreate" :show-overflow-tooltip="true" label="复审日期"></el-table-column>
              <el-table-column align="center" prop="nextReviewTime" :show-overflow-tooltip="true" label="下次复审时间"></el-table-column>
              <el-table-column align="center" prop="certificateType" label="证书类别"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="考试记录" name="ksjl">
            <el-table :data="ksData" style="width: 100%" :header-cell-style="tableTouStyle">
              <el-table-column align="center" prop="id" label="考试记录id"></el-table-column>
              <el-table-column align="center" prop="startAnswerTime" label="开始时间"></el-table-column>
              <el-table-column align="center" prop="endAnswerTime" label="结束时间"></el-table-column>

              <el-table-column align="center" prop="score" label="分数"></el-table-column>
              <el-table-column align="center" prop="answerStatus" label="答题状态"></el-table-column>
              <el-table-column align="center" prop="pass" label="是否通过">
                <template slot-scope="scope">
                  <span>{{ scope.row.pass?"已通过":"未通过" }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getMacByEmp,
  getExamrecord,
  getCertificate,
  getCultivate
} from "@/api/worker.js";
import { getPersonDetailNew } from "@/api/processManager"
import { downLoadDocument } from "@/api/downLoad"
export default {
  components: {},
  props: {
    deviceno: String
  },
  data() {
    return {
      // 表格头部样式
      tableTouStyle: {
        background: '#f1f1f1',
        color: '#000',
        'font-size': '14px',
        'text-align': 'center'
      },
      zsData: [], //证书数据
      ksData: [], //考试数据
      pxData: [], //培训数据
      yjkData: [], //应急卡数据
      totalYj: 0,
      curPageYj: 1,
      limitYj: 5,
      activeName: "cnk",
      formData: {
        picUrl: "",
        name: undefined,
        empNo: undefined,
        deptName: undefined,
        jobName: undefined,
        sex: undefined,
        shouldKnowId: undefined,
        promiseCardId: undefined,
        emergencyId: undefined,
        shouldKnowContent: "",
        emergencyContent: "",
        promiseContent: "",
        positioningDeviceNumber: undefined,
        empNo: undefined
      },
        // 三卡的数据
        emergency: {},
        promise: {},
        should: {},
        // 风险等级数组
        riskLevelArr: [
          { label: "一级", value: 1 },
          { label: "二级", value: 2 },
          { label: "三级", value: 3 },
          { label: "四级", value: 4 }
        ],
        // 安全指示标示数组
        saftyArr: [
          { label: '指示标志', value: 1 },
          { label: '警示作业安全警示标志', value: 2 },
          { label: '逃生避难警示标志', value: 3 },
          { label: '风向警示标志', value: 4 },
        ],
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          }
        ],
        deviceno: [
          {
            required: true,
            message: "请输入mac地址",
            trigger: "blur"
          }
        ],
        worktype: [
          {
            required: true,
            message: "请输入工种",
            trigger: "blur"
          }
        ],
        branchtype: [
          {
            required: true,
            message: "请输入卡类型",
            trigger: "blur"
          }
        ],
        empduties: [
          {
            required: true,
            message: "请输入岗位",
            trigger: "blur"
          }
        ],
        lasttime: [
          {
            required: true,
            message: "请输入时间",
            trigger: "blur"
          }
        ],
        workUnit: [
          {
            required: true,
            message: "请输入所属单位",
            trigger: "blur"
          }
        ],
        field108: [
          {
            required: true,
            message: "请输入电容量等级",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    init(deviceno) {
      this.deviceno=deviceno;
      this.getDetail();
      this.getExamrecordD();
      this.getExamrecordD();
      this.getCultivateD();
      this.getCertificateD();
      // this.getEmergencyData();
    },
    getDetail() {
      let _this=this
        getMacByEmp(this.deviceno).then(res => {
          _this.formData = res.data.data;
          if (_this.formData) {
            getPersonDetailNew(_this.formData.empId).then(res => {
              _this.emergency = res.body.data.emergency
              _this.promise = res.body.data.promise
              _this.should = res.body.data.should
            })
          }
          
        });
    },
    getCertificateD() {
      let _this=this
      getCertificate(this.deviceno).then(res => {
        _this.zsData = res.data.data;
      });
    },
    getExamrecordD() {
      let _this=this
      getExamrecord(this.deviceno).then(res => {
        _this.ksData = res.data.data;
      });
    },
    getCultivateD() {
      let _this=this
      getCultivate(this.deviceno).then(res => {
        _this.pxData = res.data.data;
      });
    },
    // 获取应急卡表格
    // getEmergencyData() {
    //     getPersonYj({ limit: this.limitYj, curPage: this.curPageYj, id: this.formData.emergencyId }).then(res => {
    //       this.yjkData = res.body.data
    //       this.totalYj = res.body.cum
    //     })
    // },
    // 应急卡翻页
    // handleChangeYj(val) {
    //   this.curPageYj = val
    //   this.getEmergencyData()
    // },
    

    // 下载附件
    download(url, name) {
      downLoadDocument(url, name)
    }
  }
};
</script>
<style scoped>
.wokerDetailHeader{
  width: 100%;
  height: 40px;
  text-align: center;
  line-height: 40px;
  background: rgba(243, 243, 243, 0.9);
  font-size: 18px;
}
.wokerDetailText{
  display: flex;
  justify-content: space-between;
  padding: 20px;
}
/* .wokerDetailDetail{
  width: calc(100% - 500px);
} */
.wokerDetailDetail{
  width: calc(100% - 380px);
  margin-left: 20px;
}
tr{
  text-align: center;
}
.detail{
  width: 100px;
}
#wokerDetailDiv {
  position: absolute;
  z-index: 1002;
  top: 15%;
  left: 20%;
  /* height:60%; */
  height: 560px;
  width: 60%;
  background-color: white;
}
#wokerDetailDiv /deep/ .el-tabs__item {
  padding-left: 20px;
}
.wokerDetailDetail /deep/ .el-tabs__content {
  height: 400px;
  overflow-y: scroll;
}
#wokerDetailDiv /deep/ .el-tab-pane {
  padding: 0 20px;
}
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  margin: 0;
  padding-left: 42px;
}
.text {
  font-size: 14px;
}
.text :nth-child(1) {
  color: #666;
}
.text :nth-child(2) {
  color: #333;
  font-weight: 600;
}
.item {
  margin-bottom: 18px;
}
</style>
